// extracted by mini-css-extract-plugin
export default {"ticketsWrapper":"TicketsPanel_ticketsWrapper__LUu7T","background":"TicketsPanel_background__bgI0B"};